module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_c('div', {
    staticClass: "fmh1"
  }, [_vm._v("\n    Table of Contents\n  ")]), _vm._v(" "), _c('div', [_c('br')])]), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_fm1_r1"
    }
  }, [_vm._v("COURAGE After Fire")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_frw_r1"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_itr_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1"
    }
  }, [_vm._v("Chapter 1 - Reactions to War")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1#h1"
    }
  }, [_vm._v("Positive Effects of War")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1#h2"
    }
  }, [_vm._v("Negative Effects of War")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1#h3"
    }
  }, [_vm._v("Anxiety")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1#h4"
    }
  }, [_vm._v("Posttraumatic Stress")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1#h5"
    }
  }, [_vm._v("Panic Attacks")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1#h6"
    }
  }, [_vm._v("Phobias")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1#h7"
    }
  }, [_vm._v("Anger")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1#h8"
    }
  }, [_vm._v("Substance Use")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c01_r1#h9"
    }
  }, [_vm._v("Depression")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 - Strengthening Your Mind and Body")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c02_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Strengths-Oriented Approach")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c02_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relaxation Drills")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c02_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking “Stronger” Care of Yourself")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 - Coping Strategies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c03_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combating Posttraumatic Stress")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c03_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combating Panic")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c03_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combating Anger")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c03_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combating Alcohol or Drug Abuse")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c03_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combating Depression")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 - Grief and Loss")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Is Grief?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reactions to Sudden Loss")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frequently Asked Questions about Grief")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 - Changed Views of Self, Others, and the World")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safety and Trust")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control and Power")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Future Outlook")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Worth and Self-Esteem")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relationships and Closeness")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meaning and Purpose of Life")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spirituality and Faith")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Positive Change")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c05_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coping with Changed Views")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 - Returning to Civilian Life")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Readjusting to Work")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming Home to No Job")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c06_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Readjusting to the Community")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c06_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Dumb” Questions Civilians Ask and How to Respond to Them")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 - Restoring Family Roles and Relationships")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feeling a “Part” after Being Apart")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c07_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tips for Reuniting with Your Family")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c07_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talking about Your War Experiences with Supportive Adults")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c07_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Talk with Supportive Adults")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c07_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Improving Intimate Relationships")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_c07_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reconnecting with Children")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_in1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/keit_9781569752777_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52d0232e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/keit_9781569752777_oeb_toc_r1.vue
// module id = 57
// module chunks = 0